import { on } from 'delegated-events'

const fn = {
  init: () => {
    on('click', '.toggle-more-items', fn.handleToggle)
  },

  handleToggle: (e) => {
    const section = e.target.closest('[has-more-videos]');

    if (section) {
      const videoCards = section.querySelectorAll('.more-videos > *');

      videoCards.forEach(function(card) {
        if (card.classList.contains('hidden')) {
          card.classList.remove('hidden')
          card.classList.add('extended-video-active')

          const assetIcon = section.querySelector('.toggle-more-items > svg');
            if (assetIcon) {
            assetIcon.style.transform = 'rotate(180deg)';
        }

        } else if (card.classList.contains('extended-video-active')) {
          card.classList.remove('extended-video-active')
          card.classList.add('hidden')

          const assetIcon = section.querySelector('.toggle-more-items > svg');
                if (assetIcon) {
                assetIcon.style.transform = 'rotate(0deg)';
           }
        }
      })
    }
  },
}

export default {
  can: () => true,
  run: fn.init,
}
